/**
 * Lake house LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Asset DTO
 */
export interface AssetDto {
  id?: number;
  active?: boolean;
  code?: string;
  name?: string;
  qtyScale?: number;
  refPriceUsd?: number;
  fiat?: boolean;
  manualRate?: boolean;
  disabledFromHouseLp: boolean;
}
